export default ({"url":"_framework/blazor.webassembly.js","satellites":[],"noMutation":false});